var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeforeAfterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#1355FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9279 23.7951C16.9279 23.9284 16.8747 24.0562 16.78 24.1501L16.07 24.8501C15.9761 24.9448 15.8483 24.998 15.715 24.998C15.5817 24.998 15.4539 24.9448 15.36 24.8501L11.22 20.7201C11.0793 20.5796 11.0002 20.3889 11 20.1901V19.8101C11.0023 19.6117 11.0811 19.4218 11.22 19.2801L15.35 15.1501C15.4439 15.0554 15.5717 15.0022 15.705 15.0022C15.8383 15.0022 15.9661 15.0554 16.06 15.1501L16.77 15.8601C16.8641 15.9523 16.9171 16.0784 16.9171 16.2101C16.9171 16.3418 16.8641 16.4679 16.77 16.5601L13.33 20.0001L16.78 23.4401C16.8747 23.534 16.9279 23.6618 16.9279 23.7951ZM24.285 15.0022C24.1517 15.0022 24.0239 15.0554 23.93 15.1501L23.22 15.8501C23.1253 15.944 23.0721 16.0718 23.0721 16.2051C23.0721 16.3384 23.1253 16.4662 23.22 16.5601L26.67 20.0001L23.22 23.4401C23.1259 23.5323 23.0729 23.6584 23.0729 23.7901C23.0729 23.9218 23.1259 24.0479 23.22 24.1401L23.93 24.8501C24.0239 24.9448 24.1517 24.998 24.285 24.998C24.4183 24.998 24.5461 24.9448 24.64 24.8501L28.78 20.7201C28.9189 20.5784 28.9977 20.3885 29 20.1901V19.8101C28.9998 19.6113 28.9207 19.4206 28.78 19.2801L24.64 15.1501C24.5461 15.0554 24.4183 15.0022 24.285 15.0022Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "white",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeAfterIcon);
export default __webpack_public_path__ + "static/media/before-after-icon.9917fbe92cc6e6372eb995ddc4c1b82c.svg";
export { ForwardRef as ReactComponent };